import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StartPageComponent } from './views/start-page/start-page.component';
import { TripMapComponent } from './views/trip-map/trip-map.component';
import { RankingComponent } from './views/ranking/ranking.component';
import { ResultComponent } from './views/result/result.component';

const routes: Routes = [
  { path: '', redirectTo: '/start-page', pathMatch: 'full' },
  { path: 'start-page', component: StartPageComponent },
  { path: 'trip-map', redirectTo: '/trip-map/1', pathMatch: 'full' },
  { path: 'trip-map/:id', component: TripMapComponent },
  { path: 'ranking/:id', component: RankingComponent },
  { path: 'ranking', component: RankingComponent },

  { path: 'result/:id', component: ResultComponent },
  { path: 'result', redirectTo: '/start-page', pathMatch: 'full' },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/app-routing.module.ts